
export const constants = {
  IDENTITY_CONTRACT_ADDRESS: '0x04eEe47DA1e717fb561263153946B0fDEf798351',
  geoapifyKey: '857b1183718d4204ae77cf82c6a24550',
  namespace: 'evdashboard.apps.elia.iam.ewc',
  assetPrequalification: {
    prequalifiedRole: 'prequalified.roles.flexmarket.apps.elia.iam.ewc' 
  }
};
